import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { KeyAppointmentModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { KeyAppointmentAction } from '../actions';
import { KeyAppointmentReducer } from '../reducers';
import { KeyAppointmentSelector } from '../selectors';

@Injectable()
export class KeyAppointmentFacade {
  selectedItem$ = this._store.select(KeyAppointmentSelector.selectKeyAppointment);
  constructor(private _store: Store<KeyAppointmentReducer.KeyAppointmentState>) {}

  /**
   * Get @KeyAppointmentModel by id
   */
  getById(id: number): Observable<KeyAppointmentModel | null> {
    this._store.dispatch(KeyAppointmentAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<KeyAppointmentModel | null>;
  }
}
